/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diaglab-sample.reducer';

export const DiaglabSample = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diaglabSampleList = useAppSelector(state => state.diaglabSample.entities);
  const loading = useAppSelector(state => state.diaglabSample.loading);
  const totalItems = useAppSelector(state => state.diaglabSample.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diaglab-sample-heading" data-cy="DiaglabSampleHeading">
        <Translate contentKey="tinyMedicRestApp.diaglabSample.home.title">Diaglab Samples</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diaglabSample.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/diaglab-sample/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diaglabSample.home.createLabel">Create new Diaglab Sample</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diaglabSample.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diaglabSampleList && diaglabSampleList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('accessionNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.accessionNumber">Accession Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accessionNumber')} />
                </th>
                <th className="hand" onClick={sort('domain')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.domain">Domain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('domain')} />
                </th>
                <th className="hand" onClick={sort('clientReferenceRemarks')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.clientReferenceRemarks">Client Reference Remarks</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clientReferenceRemarks')} />
                </th>
                <th className="hand" onClick={sort('priority')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.priority">Priority</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('priority')} />
                </th>
                <th className="hand" onClick={sort('quantity')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.quantity">Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantity')} />
                </th>
                <th className="hand" onClick={sort('collectionDate')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.collectionDate">Collection Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectionDate')} />
                </th>
                <th className="hand" onClick={sort('revision')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.revision">Revision</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('revision')} />
                </th>
                <th className="hand" onClick={sort('referredToOrFrom')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.referredToOrFrom">Referred To Or From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredToOrFrom')} />
                </th>
                <th className="hand" onClick={sort('sourceOfSample')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.sourceOfSample">Source Of Sample</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sourceOfSample')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('typeOfSample')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.typeOfSample">Type Of Sample</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('typeOfSample')} />
                </th>
                <th className="hand" onClick={sort('uom')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.uom">Uom</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uom')} />
                </th>
                <th className="hand" onClick={sort('rejectReason')}>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.rejectReason">Reject Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejectReason')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.diagLab">Diag Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.labBill">Lab Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diaglabSample.collector">Collector</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diaglabSampleList.map((diaglabSample, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diaglab-sample/${diaglabSample.id}`} color="link" size="sm">
                      {diaglabSample.id}
                    </Button>
                  </td>
                  <td>{diaglabSample.accessionNumber}</td>
                  <td>{diaglabSample.domain}</td>
                  <td>{diaglabSample.clientReferenceRemarks}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SamplePriority.${diaglabSample.priority}`} />
                  </td>
                  <td>{diaglabSample.quantity}</td>
                  <td>{diaglabSample.collectionDate}</td>
                  <td>{diaglabSample.revision}</td>
                  <td>{diaglabSample.referredToOrFrom}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SourceOfSample.${diaglabSample.sourceOfSample}`} />
                  </td>
                  <td>{diaglabSample.active ? 'true' : 'false'}</td>
                  <td>{diaglabSample.cursor}</td>
                  <td>{diaglabSample.lastUpdated}</td>
                  <td>{diaglabSample.microSec}</td>
                  <td>{diaglabSample.timestampEntry}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SampleStatus.${diaglabSample.status}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.TypeOfSample.${diaglabSample.typeOfSample}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.UOM.${diaglabSample.uom}`} />
                  </td>
                  <td>{diaglabSample.rejectReason}</td>
                  <td>
                    {diaglabSample.diagLab ? <Link to={`/diag-lab/${diaglabSample.diagLab.id}`}>{diaglabSample.diagLab.id}</Link> : ''}
                  </td>
                  <td>
                    {diaglabSample.labBill ? <Link to={`/diaglab-bill/${diaglabSample.labBill.id}`}>{diaglabSample.labBill.id}</Link> : ''}
                  </td>
                  <td>
                    {diaglabSample.collector ? (
                      <Link to={`/diaglab-assistant/${diaglabSample.collector.id}`}>{diaglabSample.collector.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/diaglab-sample/${diaglabSample.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diaglab-sample/${diaglabSample.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diaglab-sample/${diaglabSample.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diaglabSample.home.notFound">No Diaglab Samples found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diaglabSampleList && diaglabSampleList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiaglabSample;
